import React from 'react';
import { ArrowUp, Code2, Heart } from 'lucide-react';
import { portfolioData } from '../data/portfolioData';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="container footer-container">
        <div className="footer-brand">
          <a href="#home" className="logo">
            <div className="logo-icon">
              <Code2 size={20} />
            </div>
            <span className="logo-text">
              {portfolioData.name}<span className="text-gradient">{portfolioData.lastName}</span>
            </span>
          </a>
          <p className="footer-tagline">
            Senior Full Stack Developer & Technical Architect
          </p>
        </div>

        <div className="footer-copyright">
          <p>
            &copy; {currentYear} {portfolioData.fullName}. All rights reserved.
          </p>
          <p className="footer-credit">
            Engineered with <Heart size={14} className="heart-icon" /> & Experience
          </p>
        </div>

        <button className="top-btn" onClick={scrollToTop} aria-label="Scroll to top" title="Back to Top">
          <ArrowUp size={20} />
        </button>
      </div>

      <style>{`
        .footer {
          background: var(--bg-primary);
          border-top: 1px solid var(--border-color);
          padding: 3rem 0;
        }

        .footer-container {
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 1.5rem;
        }

        .footer-brand {
          display: flex;
          flex-direction: column;
          gap: 0.5rem;
        }

        .footer-tagline {
          font-size: 0.88rem;
          color: var(--text-muted);
        }

        .footer-copyright {
          text-align: center;
          font-size: 0.88rem;
          color: var(--text-muted);
        }

        .footer-credit {
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.35rem;
          margin-top: 0.25rem;
          font-size: 0.82rem;
          color: var(--text-dim);
        }

        .heart-icon {
          color: var(--accent-tertiary);
          fill: var(--accent-tertiary);
        }

        .top-btn {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          background: var(--bg-tertiary);
          border: 1px solid var(--border-color);
          color: var(--text-main);
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          transition: all 0.25s ease;
        }

        .top-btn:hover {
          color: #fff;
          background: var(--gradient-brand);
          border-color: transparent;
          transform: translateY(-4px);
          box-shadow: var(--shadow-glow);
        }

        @media (max-width: 768px) {
          .footer-container {
            flex-direction: column;
            text-align: center;
          }
          .footer-brand {
            align-items: center;
          }
        }
      `}</style>
    </footer>
  );
};
